import * as types from "../types/index";
import { setInitialState } from "../InitialState";


const INITIAL_STATE = setInitialState({
    catalog: null,
});

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.PRIVATEPOLICY_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.PRIVATEPOLICY_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                catalog: action.payload.success
            };
        case types.PRIVATEPOLICY_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                catalog: action.payload.response.error,
            };
        case types.RESET_TEST:
            return {
                ...state,
                isFetching: false,
                isError: false,
                catalog: null,
            };
        default:
            return {
                ...state
            }
    }
}